// Wraps locale.js helpers so they respect the current user's preferences
// falling back to browser locale, then USD.
import * as base from "@/lib/locale";

let _prefs = { currency: null, locale: null, timezone: null };

export function setPreferences(prefs) {
  _prefs = { ..._prefs, ...(prefs || {}) };
}

export function getLocale() {
  if (_prefs.locale) return _prefs.locale;
  return base.getLocale();
}

export function getCurrency() {
  if (_prefs.currency) return _prefs.currency;
  return base.getCurrency();
}

export function getTimezone() {
  if (_prefs.timezone) return _prefs.timezone;
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch { return "UTC"; }
}

export function formatMoney(amount, opts = {}) {
  if (amount == null || Number.isNaN(Number(amount))) return "-";
  return new Intl.NumberFormat(getLocale(), {
    style: "currency",
    currency: opts.currency || getCurrency(),
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(amount));
}

// Delegate to locale.js so callers can import the symbol helper from
// prefs without knowing whether it comes from the user profile or the
// browser fallback.
export const getCurrencySymbol = (currencyCode, locale) =>
  base.getCurrencySymbol(currencyCode || getCurrency(), locale || getLocale());

export function formatPercent(value, digits = 0) {
  if (value == null || Number.isNaN(Number(value))) return "-";
  return new Intl.NumberFormat(getLocale(), {
    style: "percent",
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(Number(value) / 100);
}

export function formatDate(dateInput) {
  if (!dateInput) return "-";
  const d = typeof dateInput === "string" ? new Date(dateInput) : dateInput;
  return new Intl.DateTimeFormat(getLocale(), {
    dateStyle: "medium",
    timeZone: getTimezone(),
  }).format(d);
}

export function formatDateTime(dateInput) {
  if (!dateInput) return "-";
  const d = typeof dateInput === "string" ? new Date(dateInput) : dateInput;
  return new Intl.DateTimeFormat(getLocale(), {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone: getTimezone(),
  }).format(d);
}

export const formatQty = base.formatQty;

// Supported currencies (major)
export const CURRENCIES = [
  "USD", "AUD", "NZD", "GBP", "EUR", "CAD", "JPY", "SGD", "HKD",
  "INR", "CHF", "SEK", "NOK", "DKK", "ZAR", "MXN", "BRL", "AED",
];

// Popular timezones (short list; users can also type a custom IANA)
export const TIMEZONES = [
  "Australia/Sydney", "Australia/Melbourne", "Australia/Brisbane", "Australia/Perth",
  "Pacific/Auckland",
  "Asia/Tokyo", "Asia/Singapore", "Asia/Hong_Kong", "Asia/Dubai", "Asia/Kolkata",
  "Europe/London", "Europe/Paris", "Europe/Berlin", "Europe/Madrid", "Europe/Zurich",
  "America/New_York", "America/Chicago", "America/Denver", "America/Los_Angeles",
  "America/Toronto", "America/Sao_Paulo", "America/Mexico_City",
  "UTC",
];

export const LOCALES = [
  "en-AU", "en-US", "en-GB", "en-NZ", "en-CA", "en-IE", "en-IN", "en-ZA",
  "fr-FR", "de-DE", "es-ES", "it-IT", "pt-BR", "pt-PT", "nl-NL",
  "ja-JP", "ko-KR", "zh-CN", "zh-HK", "zh-TW",
];
